/**
 * Component: M15 Logo and Text
 * 
 */
'use strict';

export class LogoText
{
  constructor()
  {
    this.selectors = {
      component: $('.c-v4-m15-logo-text'),
      main:      $('.c-v4-m15-logo-text--main'),
      image:     $('.c-v4-m15-logo-text--image'),
      bubbles:   $('.c-v4-m15-logo-text--image-logo')
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    $(window).on('load resize orientationchange', () => {
      this.selectors.bubbles.each(function( i, el )
      {
        if ( $(this).hasClass('has-title') )
        {
          let bubble_height = $(el).outerHeight(),
              image         = $('img', el),
              title         = $('span', el).outerHeight();

          // max image height = total bubble height - 25px padding - 10px spacing - title height
          image.css('maxHeight', bubble_height - 35 - title ).parent().addClass('ready');
        }
      });
    });
  }
}